// extracted by mini-css-extract-plugin
export default {"active":"Heart_active__Su3iM","inactive":"Heart_inactive__Yjarz"};